/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">Add Document</h4>
        <div>
            <!-- Default form login -->
            <form class="border border-light p-5" >
                <div class="row">
                    <div class="form-group col-md-12">
                        <label>Title</label>
                        <input type="text" ref="title" id="" class="form-control mb-4" placeholder="title">
                    </div>
                    <div class="form-group col-md-6">
                        <label>Category</label>
                        <select class="form-control mb-4" v-model="category" placeholder="Select a Category">
                            <option selected disabled>-- Select a Category --</option>
                            <option
                              v-for="cat in categories"
                              :key="cat._id"
                              v-bind:value="cat.title"
                            >
                              {{ cat.title }}
                            </option>
                          </select>
                    </div>
                    <div class="form-group col-md-6">
                        <label>Author</label>
                        <input type="text" ref="author" id="" class="form-control mb-4" placeholder="Author Name">
                    </div>
                    <div class="form-group col-md-6">
                        <label>Documents</label>
                        <input type="file" ref="document" id="" class="form-control mb-4" accept="application/msword, text/plain, application/pdf, .epub">
                    </div>
                </div>

                <!-- Sign in button -->
                <button class="btn btn-info btn-block my-4" @click.prevent="addDocument()">Add Document</button>

            </form>
            <!-- Default form login -->
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
export default {
    name: 'AddDocument',
    components: {

    },
    data() {
        return {
            fastAdminToken : localStorage.getItem("fastAdminToken"),
            loasing: false,
            categories: [],
            category: ""
        }
    },
    mounted() {
        this.$toast.open({
            message: "Processing : Loading Levels Please Wait...",
            type: 'info'
        })

        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }

        axios.get(this.$apiURI + "/categories", config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    
                    // eslint-disable-next-line no-console
                    // console.log(response.data.data.teachers)
                    this.categories = response.data.data.categories
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
        },
    methods: {
        addDocument() {
            if(this.loading) return;
           
            if(this.$refs.title.value == '') {
                this.$toast.open({
                        message: "Error : Please add title",
                        type: 'error'
                    })
                return;
            }

            if(this.category == '') {
                this.$toast.open({
                        message: "Error : Please add category",
                        type: 'error'
                    })
                return;
            }

            if(this.$refs.author.value == '') {
                this.$toast.open({
                        message: "Error : Please add author",
                        type: 'error'
                    })
                return;
            }

            if(this.$refs.document.files.length == 0) {
                this.$toast.open({
                        message: "Error : Please add a document",
                        type: 'error'
                    })
                return;
            }

            let data = {
                title: this.$refs.title.value,
                category: this.category,
                author: this.$refs.author.value,
            }

            var reader1 = new FileReader()
                reader1.readAsDataURL(this.$refs.document.files[0])
                reader1.onload = () => {
                    data['document'] = reader1.result;
                    const config = {
                        headers: {
                            Authorization: "Bearer " + this.fastAdminToken,
                            'Content-Type': 'application/json'
                        }
                    }
                    this.$toast.open({
                        message: "Processing : Adding Document. Please Wait...",
                        type: 'info'
                    })

                    this.loading = true;
                    axios.post(this.$apiURI + "/document/create", data, config)
                        .then((response) => {
                            this.loading = false;
                            if (response.data.error) {
                                this.$toast.open({
                                    message: "Error : " + response.data.message,
                                    type: 'error'
                                });
                            } else {
                                this.$refs.title.value = "";
                                this.category = "";
                                this.$refs.author.value = "";
                                this.$refs.document.value = "";
                                this.$toast.open({
                                    message: "Document Created Successfully",
                                    type: 'success'
                                })
                            }

                        }).catch((error) => {
                            this.loading = false;
                            this.$toast.open({
                                message: "Error : " + error.response.data.message,
                                type: 'error'
                            });
                        })
                };

            
        }
    }
}
</script>
